import React from 'react';
import { Helmet } from 'react-helmet-async';

const SchemaMarkup = ({ type, data = {} }) => {
    let schema = {};

    switch (type) {
        case 'organization':
            schema = {
                '@context': 'https://schema.org',
                '@type': 'Organization',
                name: 'Akeyreu',
                url: 'https://www.akeyreu.com',
                logo: 'https://www.akeyreu.com/logo.png',
                sameAs: [
                    'https://linkedin.com/company/akeyreu',
                    'https://github.com/AjR2'
                ],
                description: 'Akeyreu helps small business owners build custom websites, apps, and automation systems — without the technical headaches.'
            };
            break;

        case 'website':
            schema = {
                '@context': 'https://schema.org',
                '@type': 'WebSite',
                name: 'Akeyreu',
                url: 'https://www.akeyreu.com',
                potentialAction: {
                    '@type': 'SearchAction',
                    target: 'https://www.akeyreu.com/search?q={search_term_string}',
                    'query-input': 'required name=search_term_string'
                }
            };
            break;

        case 'article':
            schema = {
                '@context': 'https://schema.org',
                '@type': 'Article',
                headline: data.name || 'Akeyreu Blog',
                description: data.description || '',
                image: data.image || 'https://www.akeyreu.com/logo.png',
                datePublished: data.datePublished ? new Date(data.datePublished).toISOString() : new Date().toISOString(),
                url: data.url || 'https://www.akeyreu.com/blog',
                author: {
                    '@type': 'Organization',
                    name: 'Akeyreu'
                },
                publisher: {
                    '@type': 'Organization',
                    name: 'Akeyreu',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://www.akeyreu.com/logo.png'
                    }
                },
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': data.url || 'https://www.akeyreu.com/blog'
                }
            };
            break;

        default:
            return null;
    }

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export default SchemaMarkup;
